import type { ReactNode } from "react"
import {
  maxWidth480px,
  padding16,
  paddingVertical16,
  pageOuterStyle,
  width160px,
} from "@/components/style-utils"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import WavelengthLogo from "icons/WavelengthLogo"
import { useLocation } from "react-router-dom"

type PageProps = {
  children: ReactNode
}

function Page({ children }: PageProps) {
  const location = useLocation()

  return (
    <Box className="flex-center-column grow" sx={pageOuterStyle}>
      <div
        className="grow"
        style={
          location.pathname === "/login" || location.pathname === "/requestAccess"
            ? { maxWidth: "800px" }
            : maxWidth480px
        }
      >
        {children}
      </div>
      <Box className="flex-align-center" sx={padding16}>
        <WavelengthLogo sx={width160px} />
      </Box>
      <Typography align="center" sx={paddingVertical16}>
        Keep your data current and discover the best connections
      </Typography>
    </Box>
  )
}

export default Page
